import { render, staticRenderFns } from "./AppCashback.vue?vue&type=template&id=739064c2&scoped=true&"
import script from "./AppCashback.vue?vue&type=script&lang=js&"
export * from "./AppCashback.vue?vue&type=script&lang=js&"
import style0 from "./AppCashback.vue?vue&type=style&index=0&id=739064c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739064c2",
  null
  
)

export default component.exports